import api, {VersionedAPIPath} from "@/api/api";

export default {
    checkUserHasOpenWorkSession() {
        return api.get(VersionedAPIPath+'/user/get-open-work-session');
    },
    verifyWorkSession($sessionKey){
        return api.post(VersionedAPIPath+'/user/verify-work-session',{
            session_key : $sessionKey
        })
    }
}